export default "__VITE_ASSET__BYsWbKSY__"